import type { McpUsagePoint } from "@/lib/api";

/**
 * Dependency-free stacked bar chart of daily MCP calls. Each column's height is
 * that day's total calls; the segments (bottom→top) are allowed, denied, and
 * errored calls. A pure-CSS group-hover tooltip shows the exact counts.
 */
export function McpUsageChart({ data }: { data: McpUsagePoint[] }) {
  const max = Math.max(1, ...data.map((d) => d.total));

  return (
    <div className="flex h-40 items-stretch gap-1">
      {data.map((point) => {
        const heightPct = point.total ? Math.max(2, (point.total / max) * 100) : 0;
        const seg = (n: number) => (point.total ? (n / point.total) * 100 : 0);
        return (
          <div key={point.day} className="group relative flex flex-1 flex-col justify-end">
            <div
              className="flex w-full flex-col-reverse overflow-hidden rounded-t"
              style={{ height: `${heightPct}%` }}
            >
              <div className="bg-jj-green-03 w-full" style={{ height: `${seg(point.ok)}%` }} />
              <div className="bg-jj-maroon-05 w-full" style={{ height: `${seg(point.denied)}%` }} />
              <div className="bg-warm-gray-05 w-full" style={{ height: `${seg(point.errors)}%` }} />
            </div>
            <span className="bg-foreground text-background pointer-events-none absolute -top-8 left-1/2 z-10 hidden -translate-x-1/2 rounded px-1.5 py-0.5 text-[10px] whitespace-nowrap group-hover:block">
              {point.day}: {point.total} calls · {point.denied} denied · {point.errors} errors
            </span>
          </div>
        );
      })}
    </div>
  );
}
